import $ from "jquery";
const BASE_URL = "api:///v6/notifications";
const list = (data = {}) => $.ajax({
    method: "GET",
    url: BASE_URL,
    data,
});
const listByUserId = (userId, data = {}) => $.ajax({
    method: "GET",
    url: `${BASE_URL}/${userId}`,
    data,
});
const getNotificationCursor = () => $.ajax({
    method: "GET",
    url: `${BASE_URL}/read`,
});
const getNotificationCursorByUserId = (userId) => $.ajax({
    method: "GET",
    url: `${BASE_URL}/${userId}/read`,
});
const updateNotificationCursor = (payload) => $.ajax({
    method: "POST",
    url: `${BASE_URL}/read`,
    contentType: "application/json",
    data: JSON.stringify(payload),
});
const updateNotificationCursorByUserId = (userId, payload) => $.ajax({
    method: "POST",
    url: `${BASE_URL}/${userId}/read`,
    contentType: "application/json",
    data: JSON.stringify(payload),
});
export default {
    list,
    listByUserId,
    getNotificationCursor,
    getNotificationCursorByUserId,
    updateNotificationCursor,
    updateNotificationCursorByUserId,
};
